export default __webpack_public_path__ + "static/media/12.467eb6b7.jpg";